import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../../text/messages';
import Table from '../../components/table';
import PropTypes from 'prop-types';

import './invoice.css';
import { formatMoney } from '../../utilities/string';

export default class UserGroup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false
        };

        this.toggleExpand = this.toggleExpand.bind(this);
        this.renderExpand = this.renderExpand.bind(this);
        this.sortType = this.sortType.bind(this);
        this.sortDescriptionThenType = this.sortDescriptionThenType.bind(this);
        this.sortHoursThenDescription = this.sortHoursThenDescription.bind(this);
    }

    renderExpand() {
        const { expanded } = this.state;

        return expanded ? (
            <div className="expand">
                <i className="material-icons">remove</i>
            </div>
        ) : (
            <div className="expanded">
                <i className="material-icons">add</i>
            </div>
        );
    }

    toggleExpand() {
        const { expanded } = this.state;
        this.setState({ expanded: !expanded });
    }

    sortType(a, b) {
        const types = ['regular', 'overtime', 'doubletime', 'outOfWeek', 'expense', 'deliverable'];
        const aIndex = types.findIndex(t => t === a.type);
        const bIndex = types.findIndex(t => t === b.type);
        return aIndex - bIndex;
    }

    sortDescriptionThenType(a, b, desc = false) {
        const [aprime, bprime] = desc ? [b, a] : [a, b];
        const descriptionSort = aprime.description.localeCompare(bprime.description);
        if (descriptionSort !== 0) return descriptionSort;
        return this.sortType(a, b);
    }

    sortHoursThenDescription(a, b) {
        const hoursSort = (a.hours || 0) - (b.hours || 0);
        if (hoursSort !== 0) return hoursSort;
        return this.sortDescriptionThenType(a, b);
    }

    getColumnDefinition() {
        const { currency } = this.props;
        return [
            {
                label: <FormattedMessage {...messages.description} />,
                valueMap: d => <div className="full-height-cell ellipsis">{d.description}</div>,
                size: 'col-sm-4 hidden-xs',
                sort: this.sortDescriptionThenType,
                descSort: (a, b) => this.sortDescriptionThenType(a, b, true)
            },
            {
                label: <FormattedMessage {...messages.type} />,
                valueMap: d => <div className="full-height-cell ellipsis text-capitalize">{d.type}</div>,
                size: 'col-sm-2 col-xs-4',
                sort: this.sortType
            },
            {
                label: <FormattedMessage {...messages.hours} />,
                valueMap: d => <div className="full-height-cell ellipsis pull-right">{isNaN(d.hours) ? '' : d.hours.toFixed(2)}</div>,
                size: 'col-sm-3 col-md-2 col-xs-4',
                justify: 'right',
                sort: this.sortHoursThenDescription
            },
            {
                label: <FormattedMessage {...messages.billRate} />,
                valueMap: d => <div className="full-height-cell pull-right">{d.bill_rate ? d.bill_rate.toFixed(2) : ''}</div>,
                size: 'col-md-2 hidden-sm hidden-xs',
                justify: 'right',
                sort: (a, b) => (a.bill_rate || 0) - (b.bill_rate || 0)
            },
            {
                label: <FormattedMessage {...messages.amount} />,
                valueMap: d => <div className="full-height-cell pull-right ">{formatMoney(d.extended || 0, currency)}</div>,
                size: 'col-sm-3 col-md-2 col-xs-4',
                justify: 'right',
                sort: (a, b) => (a.extended || 0) - (b.extended || 0)
            }
        ];
    }

    render() {
        const { items, currency } = this.props;
        const { expanded } = this.state;
        if (!items || !items.length) {
            return null;
        }

        const { name } = items[0];
        const totalExtended = formatMoney(items.reduce((a, c) => a + c.extended, 0), currency);
        const totalHours = items.reduce((a, c) => a + (c.hours || 0), 0);

        return (
            <div className="userGroup">
                <div className="row">
                    <div className={`col-md-${expanded ? 12 : 7} col-sm-12  col-xs-12 iconCell`}>
                        <div className="name-cell">
                            <div className="groupValues" onClick={this.toggleExpand}>
                                {this.renderExpand()}
                            </div>
                            <h4 className="name-cell-value">{name}</h4>
                        </div>
                    </div>
                    {!expanded && (
                        <React.Fragment>
                            <div className="col-md-3 col-sm-6 col-xs-6">
                                <span className="groupValues invoiceLabels pull-right">
                                    {totalHours.toLocaleString(undefined, { maximumFractionDigits: 0 })} <FormattedMessage {...messages.hours} />
                                </span>
                            </div>
                            <div className="col-md-2 col-sm-6 col-xs-6">
                                <span className="groupTotal pull-right"> {totalExtended}</span>
                            </div>
                        </React.Fragment>
                    )}
                </div>
                {expanded && (
                    <div className="groupValues">
                        <div className="row">
                            <div className="col-xs-12 invoice-table-wrapper">
                                <Table data={items} columns={this.getColumnDefinition()} defaultSortColumn={0} />
                            </div>
                        </div>
                        <div className="row groupTotal">
                            <div className="col-sm-2 col-xs-8 bold">
                                <FormattedMessage {...messages.total} />
                            </div>
                            <div className="col-sm-4 hidden-xs" />
                            <div className="col-sm-2 hidden-xs">
                                <span className="bold">
                                    <div className="row">
                                        {totalHours} <FormattedMessage {...messages.hours} />
                                    </div>
                                </span>
                            </div>
                            <div className="col-sm-2 hidden-xs" />
                            <div className="col-sm-2 col-xs-4 total-cell">
                                <span>{totalExtended}</span>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

UserGroup.propTypes = {
    items: PropTypes.array.isRequired,
    currency: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/pages/invoice/userGroup.jsx